import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiService } from '../../../services/api/api.service';
import { FilterService } from '../../../services/filter/filter.service';
const name = 'DASHBOARD_PAYMENT';

export const patchInvoiceData = createAsyncThunk(`${name}/PATCH_INVOICE_DATA`,
  async ({id, invoiceName, invoiceAddress, invoiceNip, invoicePostalCode, invoiceCity}, thunkApi) => {
    try {
      const response = await ApiService.patch(`/vendor/admin/${id}/invoice`, {invoiceName, invoiceAddress, invoiceNip, invoicePostalCode, invoiceCity});
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

export const getInvoiceData = createAsyncThunk(`${name}/GET_INVOICE_DATA`,
  async ({vendorId}, thunkApi) => {
    try {
      const response = await ApiService.get(`/vendor/admin/${vendorId}/invoice`);
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

export const getTransactionsPeriod = createAsyncThunk(`${name}/GET_TRANSACTIONS_PERIODS`,
  async ({vendorId, filter}, thunkApi) => {
    try {
      let _url = FilterService.addFilter({url: `/vendor/admin/${vendorId}/transactions-periods`, filter});
      const response = await ApiService.get(_url);
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

export const getTransactions = createAsyncThunk(`${name}/GET_TRANSACTIONS`,
  async ({vendorId, filter}, thunkApi) => {
    try {
      let _url = FilterService.addFilter({url: `/vendor/admin/${vendorId}/transactions`, filter});
      const response = await ApiService.get(_url);
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

export const getTransactionsSummary = createAsyncThunk(`${name}/GET_TRANSACTIONS_SUMMARY`,
    async ({vendorId, filter}, thunkApi) => {
      try {
        let _url = FilterService.addFilter({url: `/vendor/admin/${vendorId}/transactions-summary`, filter});
        const response = await ApiService.get(_url);
        let data = response.data;
        if (response.status === 200) {
          return data;
        }
        return thunkApi.rejectWithValue(data);
      } catch (e) {
        return thunkApi.rejectWithValue(e);
      }
    });

export const getDownloadInvoice = createAsyncThunk(`${name}/GET_DOWNLOAD_INVOICE`,
    async ({vendorId, filter}, thunkApi) => {
      try {
        let _url = FilterService.addFilter({url: `/vendor/admin/${vendorId}/download-invoice`, filter});
        const response = await ApiService.get(_url);
        let data = response;
        if (response.status === 200) {
          return data;
        }
        return thunkApi.rejectWithValue(data);
      } catch (e) {
        return thunkApi.rejectWithValue(e);
      }
    });

const initialState = {
  invoiceData: undefined,
  transactions:  [],
  invoice: undefined,
  transactionsSummary: {},
  isDisabledDownload: false,
  isFetching: false,
  isFetched: false,
  isError: false,
  errorMessage: '',
};

export const dashboardPaymentSlice = createSlice({
  name,
  initialState: initialState,
  extraReducers: {
    [getInvoiceData.fulfilled]: (state, { payload }) => {
      state.invoiceData = payload;
      state.isFetching = false;
      state.isFetched = true;
      return state;
    },
    [getInvoiceData.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [getInvoiceData.pending]: (state) => {
      state.isFetching = true;
    },
    [patchInvoiceData.fulfilled]: (state, { payload }) => {
      state.invoiceData = payload;
      state.isFetching = false;
      state.isFetched = true;
      return state;
    },
    [patchInvoiceData.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [patchInvoiceData.pending]: (state) => {
      state.isFetching = true;
    },
    [getTransactionsPeriod.fulfilled]: (state, { payload }) => {
      state.transactionsPeriod = payload;
      state.isFetching = false;
      state.isFetched = true;
      return state;
    },
    [getTransactionsPeriod.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [getTransactionsPeriod.pending]: (state) => {
      state.isFetching = true;
    },
    [getTransactions.fulfilled]: (state, { payload }) => {
      state.transactions = payload.data;
      state.isFetching = false;
      state.isFetched = true;
      return state;
    },
    [getTransactions.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [getTransactions.pending]: (state) => {
      state.isFetching = true;
    },
    [getTransactionsSummary.fulfilled]: (state, { payload }) => {
      state.transactionsSummary = payload;
      state.isFetching = false;
      state.isFetched = true;
      return state;
    },
    [getTransactionsSummary.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [getTransactionsSummary.pending]: (state) => {
      state.isFetching = true;
    },
    [getDownloadInvoice.fulfilled]: (state, { payload }) => {
      state.invoice = payload.data;
      state.isFetching = false;
      state.isFetched = true;
      state.isDisabledDownload = payload.data?.url === null;
      return state;
    },
    [getDownloadInvoice.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.isDisabledDownload = true;
      state.errorMessage = payload?.message || '';
    },
    [getDownloadInvoice.pending]: (state) => {
      state.isFetching = true;
      state.isDisabledDownload = true;
    },
  }
});
